import React from 'react';
import style from './index.module.css';
import { getImage } from '../../utils/utils';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';

const PlanMarry = (props) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	return (
		<div className={style.planMarrySection} style={{ backgroundColor: isDark ? '#1a1a1a' : '#f5f5f5' }}>
			<motion.img
				whileHover={{ scale: 1.05 }}
				className={style.imageStyle}
				src={getImage('image9')}
				alt='Wedding plan 1'
			/>
			<div className={style.middleSection}>
				<motion.h1 
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					style={{ color: theme.palette.text.primary }}
				>
					Plan a Marriage
				</motion.h1>
				<div className={style.withUsSection}>
					<div className={style.lineStyle} style={{ backgroundColor: theme.palette.primary.main }}></div>
					<h3 style={{ padding: '0 1rem', color: theme.palette.primary.main }}>with us</h3>
					<div className={style.lineStyle} style={{ backgroundColor: theme.palette.primary.main }}></div>
				</div>
				<motion.img
					initial={{ scale: 0.8, opacity: 0 }}
					whileInView={{ scale: 1, opacity: 1 }}
					viewport={{ once: true }}
					className={style.middleImageStyle}
					src={getImage('image8')}
					alt='Wedding focus'
				/>
			</div>
			<motion.img
				whileHover={{ scale: 1.05 }}
				className={style.imageStyle}
				src={getImage('image10')}
				alt='Wedding plan 2'
			/>
		</div>
	);
};

export default PlanMarry;
